import StatisticDetailContainer from './StatisticDetailContainer';
export default StatisticDetailContainer;
